export default __webpack_public_path__ + "static/media/cavalieri.2b8c7611.jpg";